import { postLoginInstance } from "../../utils";
import { API_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllCustomerData } from "./CustomersAction";
import { toast } from "react-toastify";


export const getCustomerNameApi = (ctx = null) => {

  ctx.setState({ detailLoading: true })
  ctx?.setState?.({ isLoading: true })

  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const page = params.get("page") || "";
    const pageSize = params.get("pageSize") || "";
    return postLoginInstance.get(`customer?pageSize=${pageSize || API_LIMIT}&pageNumber=${page || START_PAGE}${searchValue ? `&searchValue=${searchValue}` : ""}`)
      .then((res) => {
        ctx.setState({ detailLoading: false })

        if (ctx.state.isDropdown) {
          const customerList = res.data.data.list.map((item) => ({
            ...item,
            label: item.firstName + " " + item.lastName,
            value: item.uuid
          }))
          return ctx.setState({ customerList });
        } else {
          dispatch(getAllCustomerData(res.data.data, ctx?.state.currentPage || START_PAGE));
          ctx.setState({ detailLoading: false })

        }
      }).finally(() => {
        ctx?.setState?.({ isLoading: false})
      })
  }

};

export const getCustomerNameDropdownApi = (ctx = null) => {

  ctx.setState({ detailLoading: true })

  return function (dispatch, getState) {
    return postLoginInstance.get(`customer/list?pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}${ctx.state.search ? `&searchValue=${ctx.state.search}` : ""}`)
      .then((res) => {
        ctx.setState({ detailLoading: false })

        if (ctx.state.isDropdown) {
          const customerList = res.data.data.list.map((item) => ({
            ...item,
            label: item.firstName + " " + item.lastName,
            value: item.uuid
          }))
          return ctx.setState({ customerList });
        } else {
          dispatch(getAllCustomerData(res.data.data, ctx?.state.currentPage || START_PAGE));
          ctx.setState({ detailLoading: false })

        }
      });
  }

};





export const getDetaisCustomerApi = (path, ctx) => {
  ctx.setState({ subscriptionLoading: true });
  return postLoginInstance.get(`${path}/${ctx.props.match?.params.adsID}`)
    .then((res) => {
      ctx.setState({ subscriptionLoading: false });

      return ctx.setState({ data: res.data.data });
    })
    .catch((err) => {

    })
}

export const deleteCustomerApi = (id, ctx) => {
  return postLoginInstance.delete(`customer/${id}`)
    .then((res) => {
      toast.success(res.data.message || "Deleted Successfully");
      ctx.props.getCustomerNameApi(ctx);
      ctx.openCloseDeleteModal();
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    });
};

export const getCustomerLoginDetailsApi = async (userId) => {
  try {
    const response = await postLoginInstance.get(`customer/login-details/${userId}`);
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
    return null;
  }
};

export const resetCustomerSpecsApi = async (userId) => {
  try {
    const response = await postLoginInstance.patch(`customer/reset-specs/${userId}`);
    if (response.status > 199 && response.status < 250) {
      toast.success(response?.data?.message || "Usage exempted successfully");
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
    return null;
  }
};


